import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

import Forms from '@/store/modules/forms'
import Dialogs from './modules/dialogs'

import { HeaderGral } from '@/store/configuracion'
Vue.use(Vuex)

axios.interceptors.response.use((response) => {
  // Handle the response here
  return response
}, (error) => {
  // Handle errors here
  return Promise.reject(error)
})

export default new Vuex.Store({
  state: {
    urls: null,
    logo: null,
    dialogMain: {
      dialog: false,
      type: '',
      withWindows: 500,
      title: '',
      body: {}
    },
    objectAccess: {},
    objectCloseAccess: {},
    objectImport: {},
    objects: [],
    objectsTwo: [],
    object: {},
    objectDelete: {},
    objectPagination: {},
    dataDinamic: {},
    objectsSecound: [],
    objectSecound: {},
    export: {},
    options: {},
    model: {},
    reload: {}
  },
  getters: {
    get_urls (state) {
      return state.urls
    },
    get_logo (state) { return state.logo },
    get_dialogMain (state) {
      return state.dialogMain
    },
    get_objectAccess (state) {
      return state.objectAccess
    },
    get_objectCloseAccess (state) {
      return state.objectCloseAccess
    },
    get_objectImport (state) {
      return state.objectImport
    },
    get_objects (state) {
      return state.objects
    },
    get_objectsTwo (state) {
      return state.objectsTwo
    },
    get_object (state) {
      return state.object
    },
    get_objectDelete (state) {
      return state.objectDelete
    },
    get_objectPagination (state) {
      return state.objectPagination
    },
    get_dataDinamic (state) {
      return state.dataDinamic
    },
    get_objectsSecound (state) {
      return state.objectsSecound
    },
    get_objectSecound (state) {
      return state.objectSecound
    },
    get_export (state) {
      return state.export
    },
    get_options (state) {
      return state.options
    },
    get_model (state) {
      return state.model
    },
    get_reload (state) {
      return state.reload
    }
  },
  mutations: {
    GET_URLS_SERVER (state, urls) {
      state.urls = {}
      state.urls = urls
    },
    GET_URL_LOGO (state, logo) {
      state.logo = {}
      state.logo = logo
    },
    SHOW_DIALOG_MAIN (state, data) {
      state.dialogMain.dialog = true
      state.dialogMain.type = data.type
      state.dialogMain.form = (data.form) ? data.form : 'form'
      state.dialogMain.withWindows = (data.with) ? data.with : 500
      state.dialogMain.title = (data.title) ? data.title : ''
      state.dialogMain.body = (data.body) ? data.body : {}
    },
    HIDDE_DIALOG_MAIN (state) {
      state.dialogMain.dialog = false
      state.dialogMain.type = ''
    },

    POST_DATA_LOGIN (state, data) {
      state.objectAccess = {}
      state.objectAccess = data
    },
    POST_DATA_LOGOUT (state, data) {
      state.objectCloseAccess = {}
      state.objectCloseAccess = data
    },

    POST_DATA_IMPORT_SERVER (state, data) {
      state.objectImport = {}
      state.objectImport = data
    },
    GET_DATA_SERVER_LIST (state, data) {
      state.objects = []
      state.objects.push(...data)
    },
    GET_DATA_SERVER_LIST_TWO (state, data) {
      state.objectsTwo = []
      state.objectsTwo.push(...data)
    },
    GET_DATA_SERVER (state, data) {
      state.object = {}
      state.object = data
    },
    GET_DATA_SERVER_PAGINATION (state, data) {
      state.objectPagination = {}
      state.objectPagination = data
    },
    POST_DATA_DINAMIC_SERVER (state, data) {
      state.dataDinamic = {}
      state.dataDinamic = data
    },
    GET_DATA_EXPORT (state, data) {
      state.export = {}
      state.export = data
    },

    GET_DATA_SERVER_LIST_SECOUND (state, data) {
      state.objectsSecound = []
      state.objectsSecound.push(...data)
    },
    // Setters Data
    SET_DATA (state, data) {
      let findobject = -1
      state.objects.map((el, i) => {
        if (el.id === data.id) {
          findobject = i
        }
      })
      if (findobject !== -1) {
        Object.assign(state.objects[findobject], data)
      } else {
        state.objects.push(data)
      }
    },
    SET_DATA_STRING (state, data) {
      let findobject = -1
      state.objects.map((el, i) => {
        if (el.cve_empleado === data.cve_empleado) {
          findobject = i
        }
      })
      if (findobject !== -1) {
        Object.assign(state.objects[findobject], data)
      } else {
        state.objects.push(data)
      }
    },
    SET_RELOAD_DATA (state, data) {
      state.reload = data
    },
    SET_DELETE_DATA (state, data) {
      // state.objectDelete = data
      state.objects = state.objects.filter(el => el.id !== data.id)
    },

    CLEAR_DATA (state) {
      state.object = {}
    },
    CLEAR_DATA_LIST (state) {
      state.objects = []
    },
    // MODELS PROCESS
    OPTION_NEXT_ACTION (state, options) {
      state.options = {}
      state.options = options
    },
    EXECUTE_ACTION (state, action) {
      state.model = {}
      state.model = action
    }
  },
  actions: {
    getUrlServices ({ commit }) {
      axios.get('/routes').then(response => {
        commit('GET_URLS_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    urlPostServiceLoginAction ({ commit }, action) {
      axios.post(`${action.url.uri}`, action.data).then(response => {
        commit('POST_DATA_LOGIN', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          } else if (error.response.data.message) {
            Vue.swal({
              type: 'error',
              icon: 'error',
              title: 'Ooops!',
              text: error.response.data.message
            })
          }
        })
    },
    urlPostServiceLogoutAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      axios.get(`${action.url.uri}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('POST_DATA_LOGOUT', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    postUrlImportDataServerAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      let data = null
      let boundary = ''
      if (action.type !== 'json') {
        const formData = new FormData()
        formData.append('file', action.data.file)
        formData.append('key', action.data.key)
        data = formData
        boundary = `; boundary=${formData._boundary}`
      } else {
        data = action.data
        boundary = ''
      }
      axios.post(`${action.link}`, data, {
        headers:
        {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data' + boundary
        }
      }).then(response => {
        commit('POST_DATA_IMPORT_SERVER', response.data)
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },

    getUrExportDataServerAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      let params = ''
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.defaults.headers = { Authorization: `Bearer ${token}` }
      axios.get(`${url}${params}`, { responseType: 'blob' }).then(response => {
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${action.nombre}.xlsx`
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },
    GETUrlLogoSistema ({ commit }, nombre) {
      axios.get(`/logo/login/${nombre}`).then((response) => {
        commit('GET_URL_LOGO', response.data)
      }).catch((error) => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },
    postUrlExportDataServerAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      let params = ''
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.defaults.headers = { Authorization: `Bearer ${token}` }
      axios.post(`${url}${params}`, action.data, { responseType: 'blob' }).then(response => {
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${action.nombre}.xlsx`
        link.click()
        URL.revokeObjectURL(link.href)
        setTimeout(() => { commit('HIDDEN_MAIN_PROGRESS_DIALOG', response.data) }, 1000)
      }).catch(error => {
        if (error != null) {
          commit('HIDDEN_MAIN_PROGRESS_DIALOG', {})
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },

    getUrExporPdftDataServerAction ({ commit }, action) {
      // console.log(action)
      const token = Vue.$cookies.get('token_sirh')
      let params = ''
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.defaults.headers = { Authorization: `Bearer ${token}` }
      axios.get(`${url}${params}`, { responseType: 'blob' }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${action.nombre}.pdf`
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },

    getUrExportZipDataServerAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      let params = ''
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.defaults.headers = { Authorization: `Bearer ${token}` }
      axios.get(`${url}${params}`, { responseType: 'blob' }).then(response => {
        if (response.data.type === 'application/zip') {
          const blob = new Blob([response.data], { type: 'application/zip' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `Dispersiones_${action.nombre}.zip`
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Error: Dispersion con cuentas duplicadas'
          })
        }
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },
    // Actions Post´s
    postServiceListAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      axios.post(`${action.url.uri}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_LIST', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postServiceListActionSecound ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      axios.post(`${action.url.uri}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_LIST_SECOUND', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postServiceAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      axios.post(`${action.url.uri}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postServiceActionMultipart ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      const boundary = `; boundary=${action.data._boundary}`
      axios.post(`${action.url.uri}`, action.data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data' + boundary
        }
      }).then(response => {
        // commit('GET_DATA_SERVER', response.data)
        setTimeout(() => { commit('HIDDEN_MAIN_PROGRESS_DIALOG', response.data) }, 1000)
      })
        .catch(error => {
          if (error != null) {
            commit('HIDDEN_MAIN_PROGRESS_DIALOG', {})
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor !!'
            })
          }
        })
    },
    postServicePaginationAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      axios.post(`${action.url.uri}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_PAGINATION', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postUrExporPdftDataServerAction ({ commit }, action) {
      // console.log(action)
      const token = Vue.$cookies.get('token_sirh')
      let params = ''
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.defaults.headers = { Authorization: `Bearer ${token}` }
      axios.post(`${url}${params}`, action.data).then(response => {
        const file = response.data
        const linkSource = `data:application/pdf;base64,${file.pdf}`
        const downloadLink = document.createElement('a')
        downloadLink.href = linkSource
        downloadLink.download = file.nombre
        downloadLink.click()
        // const pdfWindow = window.open('')
        // pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(file.pdf) + "'></iframe>")
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },
    // END Actions Post´s

    // Actions Put´s
    putServiceAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      let params = ''
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.put(`${url}${params}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    // END Actions Put´s

    // Actions Get´s
    getServicesActionParams ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      let params = ''
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.get(`${url}${params}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_EXPORT', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    GETListObjectsService ({ commit }, action) {
      const header = HeaderGral()
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, action.params)
      } else if (action.addicional) {
        url = action.url.uri + action.addicional
      }
      axios.get(`${url}`, header).then((response) => {
        commit('GET_DATA_SERVER_LIST', response.data)
      })
        .catch((error) => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    GETListObjectsTwoService ({ commit }, action) {
      const header = HeaderGral()
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, action.params)
      } else if (action.addicional) {
        url = action.url.uri + action.addicional
      }
      axios.get(`${url}`, header).then((response) => {
        commit('GET_DATA_SERVER_LIST_TWO', response.data)
      })
        .catch((error) => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    // Actions Delete´s
    deleteServiceAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      let params = ''
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.delete(`${url}${params}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('SET_DELETE_DATA', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    deleteObjetServiceAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      let params = ''
      let url = action.url.uri
      if (action.params) {
        url = action.url.uri.replace(action.replace, '')
        params = action.params
      }
      axios.delete(`${url}${params}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('SET_DATA', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    // END Actions Delete´s

    // Actions Main Process
    GetFormOptionServicesAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      if (action.params) {
        action.url.uri = action.url.uri.replace('/{procss}[/{id}]', action.params)
      }
      axios.get(`${action.url.uri}`, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          commit('OPTION_NEXT_ACTION', response.data)
        })
        .catch(error => {
          if (error != null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postExecuteAction ({ commit }, action) {
      const token = Vue.$cookies.get('token_sirh')
      axios.post(`${action.url.uri}`, action.data, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          commit('EXECUTE_ACTION', response.data)
        })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    }
  },
  modules: {
    Forms,
    Dialogs
  }
})
